export * from './level.js'
export * from './rate-of-perceived-exertion.js'
export * from './unit.js'
export * from './weight.js'
export { default as VERSION } from './version.js'
export * from './routes.js'
export const EXPO_MANIFEST_EXTRA = {}
export const EXPO_MANIFEST = {}

export const AWS_CLOUD_FRONT_ENDPOINT = 'https://cdn-training.gymaholic.co'
export const AWS_S3_ENDPOINT = 'https://gymaholic-training.s3.amazonaws.com'
